'use client';

import { FormProvider, useForm } from 'react-hook-form';

import useLoginMutation from '@/app/(auth)/login/hooks/useLoginMutation';
import Button from '@/components/buttons/Button';
import Input from '@/components/form/Input';
import UnstyledLink from '@/components/links/UnstyledLink';
import Typography from '@/components/Typography';
import { LoginRequest } from '@/types/login';

export default function LoginForm() {
  //#region  //*=========== Form ===========
  const methods = useForm<LoginRequest>({
    mode: 'onTouched',
  });
  const { handleSubmit } = methods;
  //#endregion //*======== Form ===========

  //#region  //*=========== Submit Handler ===========
  const { mutate: mutateLogin, isPending } = useLoginMutation();
  const onSubmit = (data: LoginRequest) => {
    mutateLogin(data);
  };
  //#endregion //*======== Submit Handler ===========

  return (
    <section className='rounded-t-2xl bg-white p-5 '>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className='space-y-4'>
          <Input
            id='email'
            label='Email'
            type='email'
            placeholder='Masukkan Email'
            validation={{
              required: 'Email harus diisi',
            }}
            helperText='Format email: example@mail.com'
          />
          <Input
            id='password'
            label='Password'
            type='password'
            placeholder='Masukkan Password'
            validation={{
              required: 'Kata sandi harus diisi',
            }}
          />

          <div className='text-right'>
            <UnstyledLink
              href='/forgot-password'
              className='font-medium text-primary-info-main hover:text-primary-info-hover hover:underline'
            >
              Lupa Password?
            </UnstyledLink>
          </div>

          <Button
            type='submit'
            variant='primary'
            size='lg'
            className='w-full'
            isLoading={isPending}
          >
            <Typography
              as='p'
              variant='btn'
              weight='medium'
              className='text-typo-main'
            >
              Masuk
            </Typography>
          </Button>

          <Typography as='p' variant='c' className='text-center'>
            Belum punya akun?{' '}
            <UnstyledLink
              href='/register'
              className='font-bold text-primary-info-main hover:text-primary-info-hover hover:underline'
            >
              Daftar
            </UnstyledLink>
          </Typography>
        </form>
      </FormProvider>
    </section>
  );
}
